import React from "react";
import Trustpilot from "@/assets/svgs/TrustPilot";
import TrustpilotStar from "@/assets/svgs/TrustPilotStar";
import "./TrustPilot.css";

function TrustPilot() {
  return (
    <a
      href="https://de.trustpilot.com/review/autoeinfachlos.at"
      target="_blank"
      rel="noopener noreferrer"
      className="TrustPilot"
    >
      <Trustpilot className="TrustPilot-image" />
      <TrustpilotStar className="TrustPilotStar-image" />
      <span>350+ Bewertungen</span>
    </a>
  );
}

export default TrustPilot;
